import React from "react";
import { FileSimpleIcon, IProps as IIconProps } from "../../components/icon";
import Tooltip from "../../components/tooltip";
import { FileIconWithStatusStyled, StatusText } from "./Inbox.styles";
import { useTranslation } from "react-i18next";
import { ApprovalStatusTypeCode } from "@odata/GeneratedEnums";

interface IStatusIconProps extends Omit<IIconProps, "status"> {
    status: ApprovalStatusTypeCode;
}

function getTranslationFromStatus(status: ApprovalStatusTypeCode): string {
    switch (status) {
        case ApprovalStatusTypeCode.Pending:
            return "WaitingForApproval";
        case ApprovalStatusTypeCode.Rejected:
            return "Denied";
        default:
            return null;
    }
}

const FileIconWithStatus: React.FC<IStatusIconProps> = ({ status, ...passProps }) => {
    const { t } = useTranslation("Inbox");
    const icon = (<FileSimpleIcon {...passProps}/>);
    const key = getTranslationFromStatus(status);

    if (!key) {
        return icon;
    }

    const tooltipContent = (
        <StatusText _status={status}>
            {t(`Inbox:TableView.${key}`)}
        </StatusText>
    );

    return (
        <Tooltip content={tooltipContent}>
            {(ref) => (
                <FileIconWithStatusStyled _status={status} ref={ref}>
                    {icon}
                </FileIconWithStatusStyled>
            )}
        </Tooltip>
    );
};

export default FileIconWithStatus;
